import React, {useState} from 'react';
import {FieldArray, useFormikContext} from "formik";
import useStyles from "../styles";
import {Button, Grid, Typography} from "@material-ui/core";
import ThumbAffinity from "../../../../../ThumbAffinity";
import ClearIcon from "@material-ui/icons/Clear";
import {VscCloudUpload} from "@react-icons/all-files/vsc/VscCloudUpload";
import close_x from "../../../../../../assets/images/close_x.png";


const productDetailsDict = {
    0: {
        title: "Tercero básico",
        description: "Responsabilidad civil + Robo e incendio"
    },
    1: {
        title: "Tercero completo",
        description: "Responsabilidad civil + Robo e incendio total y parcial + Destrucción total + Adicionales (cristales, granizo, cerraduras, etc.)"
    },
    2: {
        title: "Todo riesgo",
        description: "Seguro total con franquicia"
    },
}


export default function CoberturaFormMobile(props) {
    const classes = useStyles();
    const [modalOpen, setModalOpen] = useState(false);
    const [detailsID, setDetailsID] = useState(0);
    const {setFieldValue, values} = useFormikContext();

    const {
        formField: {carProdSelected, comments, uploadedFile},
    } = props;


    const handleChange = (e) => {
        if (e.target.name === carProdSelected.name) {
            values.carProdSelected = e.target.id;
        } else {
            values.comments = e.target.value;
        }
    };

    const handleClose = () => {
        setModalOpen(false);
    }

    const openDetails = (detailID) => {
        setModalOpen(true);
        setDetailsID(detailID)
    }

    return (
        <React.Fragment>
            <div style={{display: "flex", flexDirection: "column"}}>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    marginBottom: "20px"
                }}>
                    <div style={{display: "flex", flexDirection: "column",}}>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                            }}
                        >
                            <label
                                className={classes.EncodeSansFont}
                                style={{fontSize: "18px"}}
                            >
                                <input
                                    name={carProdSelected.name}
                                    id="0"
                                    className={classes.radioCheck}
                                    type="radio"
                                    onChange={handleChange}
                                />
                                Tercero básico
                            </label>
                            <label className={classes.verDetalles}
                                   onClick={() => openDetails(0)}
                            >
                                VER DETALLES
                            </label>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                            }}
                        >
                            <label
                                className={classes.EncodeSansFont}
                                style={{fontSize: "18px"}}
                            >
                                <input
                                    name={carProdSelected.name}
                                    id="1"
                                    className={classes.radioCheck}
                                    type="radio"
                                    onChange={handleChange}
                                />
                                Tercero completo
                            </label>
                            <label className={classes.verDetalles} onClick={() => openDetails(1)}>
                                VER DETALLES
                            </label>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                            }}
                        >
                            <label
                                className={classes.EncodeSansFont}
                                style={{fontSize: "18px"}}
                            >
                                <input
                                    name={carProdSelected.name}
                                    id="2"
                                    className={classes.radioCheck}
                                    type="radio"
                                    onChange={handleChange}
                                />
                                Todo riesgo
                            </label>
                            <label className={classes.verDetalles} onClick={() => openDetails(2)}>
                                VER DETALLES
                            </label>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                            }}
                        >
                            <input
                                name={carProdSelected.name}
                                id="3"
                                className={classes.radioCheck}
                                type="radio"
                                onChange={handleChange}
                            />
                            <label
                                className={classes.EncodeSansFont}
                                style={{
                                    fontSize: "18px",
                                    maxWidth: "200px",
                                    textAlign: "start",
                                    marginLeft: "50px",
                                    marginTop: "-20px",
                                    lineHeight: "21px",
                                }}
                            >
                                Quiero conocer distintas opciones
                            </label>

                        </div>

                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-around"}}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <label
                            className={classes.EncodeSansFont}
                            style={{
                                fontSize: "14px",
                                marginBottom: "15px",
                                maxWidth: "180px",
                                textAlign: "start",
                            }}
                        >
                            Agregue información adicional:
                        </label>
                        <textarea
                            className={classes.inputTextArea}
                            placeholder="Detallá tu cobertura y costo actual"
                            name={comments.name}
                            onChange={handleChange}
                        />

                        <label
                            className={classes.EncodeSansFont}
                            style={{
                                fontSize: "14px",
                                marginBottom: "15px",
                                marginTop: "15px",
                                maxWidth: "250px",
                                textAlign: "start",
                            }}
                        >
                           Subí tu póliza actual y accedé a un mejor precio
                        </label>

                        <div style={{
                            padding: '16px', width: '100%', border: '0.5px dashed #7F7F7F',
                            borderRadius: '8px',
                        }}>
                            <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
                                {(values.archivos.length < 6) && (

                                    <Button
                                        variant="contained"
                                        component="label"
                                        className={classes.buttonForm}
                                        style={{
                                            marginBottom: '20px',
                                            backgroundColor: '#BB0D66',
                                            textTransform:'none',

                                        }}
                                    >
                                        <Typography style={{color: '#fff', display:'flex', alignItems:'center'}}>
                                            <VscCloudUpload style={{
                                                fontSize:'20px',
                                                marginRight:'8px'
                                            }}/>
                                            {values.archivos.length === 0 ? 'Subir Archivo' : 'Subir Otro Archivo'}
                                        </Typography>
                                        <input id="file" name="file" type="file" hidden
                                               onChange={(event) => {
                                                   if (event.currentTarget.files[0] !== undefined) {
                                                       let jsonFile = {
                                                           "name": event.currentTarget.files[0].name,
                                                           "content": "",
                                                           "filetype": event.currentTarget.files[0].type,
                                                           "file": event.currentTarget.files[0]
                                                       };
                                                       setFieldValue('archivos', values.archivos.concat(jsonFile));
                                                   }
                                               }}
                                               accept="application/pdf,image/x-png,image/jpeg"
                                        />
                                    </Button>
                                )}

                            </Grid>
                            <Grid xs={12} style={{display: 'flex', maxWidth: '200px', overflow: 'auto'}}>
                                <FieldArray name='archivos'>{({remove}) => (
                                    values.archivos.map((file, index) => {
                                        return (
                                            <Grid item xs={6}>
                                                <ThumbAffinity index={index} values={values} file={file.file}/>
                                                <Button onClick={() => remove(index)}><ClearIcon/></Button>
                                            </Grid>
                                        )
                                    })
                                )}</FieldArray>
                            </Grid>
                        </div>

                        {/*<FileUploader name={uploadedFile.name} handleFile={uploadedFileHandler}/>*/}
                    </div>


                    </div>

            </div>

            {modalOpen &&
                <section className={classes.modalMain}>
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                        <img
                            style={{
                                marginTop: "5px",
                                marginRight: "10px",
                            }}
                            onClick={handleClose}
                            src={close_x}
                            width={"12px"}
                            height={"12px"}
                        />
                    </div>
                    <div className={classes.modalColumn}>
                        <p className={classes.modalTitle}
                           style={{marginBottom: "20px",
                           }}>{productDetailsDict[detailsID].title} </p>
                        <p className={classes.modalText}
                           style={{marginBottom: "20px"}}>{productDetailsDict[detailsID].description}</p>
                    </div>

                </section>}



        </React.Fragment>
    );
}
